import { makeRPCPost } from '~api/RpcAPI/RpcAPI';

export const removeOfferItem = async (offerCode: string) => {
    const body = [
        {
            method: 'offer.removeOfferByCode',
            params: [
                {
                    offer_code: offerCode
                }
            ]
        }
    ];

    return makeRPCPost(body);
};
